import { mutationUpdate, type UpdateHookResponse } from '../hooks'
import { useTantalimMutation } from '../mutation'
import { useFeatureCache } from './cache'
import { type FeatureUpdateInput, type FeatureData, type FeatureReplaceSuccess, toResponseError } from '@terros/common'

/** Saves the whole feature. Send the updatedAt you read; a Conflict error means someone else saved first. */
export function useUpdateFeature(): UpdateHookResponse<FeatureData, FeatureReplaceSuccess> {
  const mutation = useTantalimMutation<FeatureUpdateInput, FeatureReplaceSuccess>({
    url: '/feature/update',
  })
  const cache = useFeatureCache()

  async function update(feature: FeatureData): Promise<FeatureReplaceSuccess> {
    try {
      const res = await mutation.mutateAsync({ feature })
      if (res.type === 'success') {
        cache.clearItem(feature.featureId)
        cache.clearList()
      }
      return res
    } catch (error) {
      throw toResponseError(error)
    }
  }

  return mutationUpdate(mutation, update)
}
